// hooks/useNewBookList.ts
import { useEffect, useState } from "react";

export const useNewBookList = (newBooks: any[]) => {
    const [bookList, setBookList] = useState<any[]>([]);
    const [currentIndex, setCurrentIndex] = useState(2);
    const [dot, setDot] = useState(2);

    useEffect(() => {
        if (newBooks && newBooks.length > 0) {
            const booksWithId = newBooks.map((book, idx) => ({
                ...book,
                id: idx,
            }));
            setBookList(booksWithId);
        }
    }, [newBooks]);

    const handleBookList = (selectIndex: number): void => {
        let newIndex = selectIndex;
        const myBookList = [...bookList];

        if (selectIndex > Math.floor(myBookList.length / 2)) {
            newIndex = (currentIndex + 1) % myBookList.length;
        } else if (selectIndex < Math.floor(myBookList.length / 2)) {
            newIndex = (currentIndex - 1 + myBookList.length) % myBookList.length;
        } else {
            return;
        }

        setCurrentIndex(newIndex);

        const newBookList = myBookList.map((it) => ({
            ...it,
            id:
                (it.id +
                    myBookList.length -
                    (selectIndex > Math.floor(myBookList.length / 2) ? 1 : -1)) %
                myBookList.length,
        }));

        setBookList(newBookList);
        setDot(newIndex);
    };

    return {
        bookList,
        currentIndex,
        dot,
        setDot,
        handleBookList,
        setCurrentIndex,
    };
};
